import React from 'react';
import { Link } from 'react-router-dom';
import { useGetPodsQuery } from '../../../redux/slices/podSlice';

import styles from '../../../../stylesheets/public/components/List.module.postcss';

function PodList({ cityName, vehicleType }) {
  const { data = {}, isFetching, isSuccess } = useGetPodsQuery();
  const pods = data.pods || [];

  let title = 'Popular Food Truck Stops';
  if (cityName === 'Portland') {
    title = 'Popular Food Cart Pods';
  }

  if (!pods || pods.length < 1) {
    return null;
  }

  return (
    <div>
      <h3>{title}</h3>
      <div className={styles.List_items}>
        {pods.map((pod) => {
          if (pod.location) {
            return (
              <div
                className={styles.List_item}
                key={pod.id}
              >
                <Link to={`/schedule/${pod.location.slug}`}>
                  {pod.name} food {vehicleType.toLowerCase()}s
                </Link>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}

export default PodList;
